import { all, put, takeLatest } from "redux-saga/effects";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import { componentKey, setVisitList } from "./unsignedVisitSlice";
import store from "../../store/store";
import UnsignedVisitService from "../../services/UnsignedVisitService";

export const { getVisitNoteList } = {
  getVisitNoteList: (payload) => {
    return {
      type: "UNSIGNED_VISIT/GET_VISIT_NOTE_LIST",
      payload,
    };
  },
};

// SEARCH PARTICIPANT API CALL FUNCTION
function* getVisitNoteListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield UnsignedVisitService.getVisitNoteList(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(setVisitList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setVisitList({}));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([takeLatest(getVisitNoteList().type, getVisitNoteListAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
